import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminData } from 'src/app/models/AdminData';
import jwt_decode from 'jwt-decode'
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, catchError, map, of, tap, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AdminService {

  // პროფილის ინფორმაცია
  user = new AdminData();

  public loading = false
  public error: any

 
  // აუტორიზაციის შემოწმება
  login(value: any) {
    return new Promise(serve => {
      this.loading = true;
      this.http.post(environment.apiUrl + 'admin/login', value, {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        withCredentials: true
      }).subscribe((response: any) => {
        this.loading = false;
        this.error = {};

        // აქ response-ში refresh_token არ იქნება, ნუ ეძებ
        if (response.access_token) {
          this.setTokens(response.access_token);
          serve(true);
          return;
        }
        
        serve(false); // თუ access_token არაა
      }, (error: any) => {
        this.loading = false;
        this.error = error;
        console.log('შეცდომა: ',error)
        serve(false);
      });
    });
  }

  // ტოკენის დამახსოვრება
  setTokens(accessToken: string) {
    if (accessToken) {
      localStorage.setItem('@administrator', accessToken);
      this.parseToken(accessToken);
    }
  }

  getAdminLogin(token: any){
    if(token){
      let d : any
      d = jwt_decode(token)
      if(d.is_admin == 'admin'){
        return true
      }
    }
    return false
  }

  // ტოკენის გაშიფრვა
  parseToken(token: any =''){
    try {
      if (!token) {
        token = localStorage.getItem('@administrator');
      }
      if(token) {
        this.user.setData(jwt_decode(token));
      }
    } catch (ex) {
      console.log("error: ", ex)
    }
  }

  // არსებობს თუ არა მომხმარებელი
  isAdmin(){
    return this.user.isLogged();
  }

  role(){
     return this.user.role;
  }

  getPermissions(): string[] {
    return this.user?.permission || [];
  }

  hasPermission(permission: string): boolean {
     if (this.user.role === 'admin') {
      // ადმინს აქვს ყველა უფლება
      return true;
    }
    return this.user.permission?.includes(permission);
  }

  logout(silent: boolean = false) {
    localStorage.removeItem('@administrator');
    localStorage.removeItem('@refresh_token');
    this.user.setData({});
    if (!silent) {
      this.http.post(`${environment.apiUrl}admin/logout`, {}, { withCredentials: true }).subscribe();
    }

    this.router.navigate(['login']);
  }

  refreshToken() {
    return this.http.post<any>(environment.apiUrl + 'admin/refresh', {}, { withCredentials: true }).pipe(
      tap(response => {
        if (response.access_token) {
          this.setTokens(response.access_token);
        }
      })
    );
  }

  getAdmins(){
    return this.http.get(environment.apiUrl + 'admin/get/admins');
  }

  addAdmin(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'admin/add/admin', data);
  }

  updateAdmin(data: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'admin/update/admin', data);
  }

  getMyInfo(){
    return this.http.get(environment.apiUrl + 'auth/me');
  }

  detete(id: number){
    return this.http.delete(environment.apiUrl +  `admin/delete/admin/${id}`);
  }

  constructor(
    private http: HttpClient,
    private router: Router) {
    this.parseToken()
  }


}
